import createEnum from 'scripts/lib/create_enum';

export default createEnum('USD');



// WEBPACK FOOTER //
// ./src/scripts/domain/models/currency/currency.js